import { defineStore } from 'pinia'
import { getAuthUser, tokenIsValid } from '../services/auth'

export const useAuthStore = defineStore('auth', {
  state: () => ({
    user: null,
  }),
  actions: {
    loadUserFromLocalStorage() {
      this.user = getAuthUser()
    },
    updateUser(user) {
      this.user = { ...this.user, ...user }
      localStorage.setItem('user', JSON.stringify(this.user))
    },
    setUpAuth({ usuario, token }) {
      if (!tokenIsValid(token, usuario)) {
        throw new Error('Error inesperado, contacte con el administrador.')
      }

      const avatar =
        usuario.images.length > 0
          ? usuario.images[usuario.images.length - 1].filename
          : null

      this.user = { ...usuario, avatar }

      localStorage.setItem('user', JSON.stringify(this.user))
      localStorage.setItem('token', token)

      return {
        user: usuario,
        token,
      }
    },
  },
  getters: {
    getAuthUser: state => {
      return state.user
    },
  },
})
